module.exports = __webpack_public_path__ + "static/media/crocodile(30).cf52c080.PNG";